export default function Strap() {
    return (
      <div className="strap-container">
          <p className="text-primary-white fw-600 text-centred">
            Where smiles comes to life: Your journey to dental wellness begins
            here.
          </p>
      </div>
    );
}